/*eslint complexity: off*/
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import SyncAltIcon from '@material-ui/icons/SyncAlt';

import Paper from '~/components/Paper';
import GridItem from '~/components/GridItem';
import InputShow from '~/components/InputShow';
import PaperButtons from '~/components/PaperButtons';
import GridContainer from '~/components/GridContainer';

import Request from '~/providers/Request';
import EpayTransactionRecord from '~/records/EpayTransactionRecord';

import { historyPropType } from '~/config/routerPropTypes';
import { epayTransactions } from '~/config/routes';
import { epayTransactionStatusOptions } from '~/config/constants';

import Context from './context';

const attrName = (attr) => EpayTransactionRecord.hummanAttributeName(attr);

function ShowEpayTransaction({ history }) {
  const { id } = history.location.route.getParams();
  const { records, addRecords } = useContext(Context);
  const [record, setRecord] = useState(new EpayTransactionRecord());
  const { t } = useTranslation();
  const [loading, setLoading] = useState(!records || !records[id]);

  useEffect(() => {
    if (records && records[id]) {
      setRecord(record.updateAttributes(records[id]));
    }
    setLoading(true);
    Request.get(`/admin/epay_transactions/${id}`, {})
      .then((response) => {
        setLoading(false);
        addRecords({ data: [response.data] });
        setRecord(record.updateAttributes(response.data));
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  return (
    <Paper
      Icon={SyncAltIcon}
      iconColor="blue"
      title={t('epayTransactions.defSingular')}
      loading={loading}
      actions={
        <PaperButtons
          id={id}
          setModal={null}
          backRoute={epayTransactions}
          newRoute={null}
          editRoute={null}
        />
      }
    >
      <GridContainer>
        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow label={attrName('id')} value={record.get('id')} />
        </GridItem>

        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow label={attrName('tx_id')} value={record.get('tx_id')} />
        </GridItem>

        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow label={attrName('tx_ref')} value={record.get('tx_ref')} />
        </GridItem>

        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow label={attrName('type')} value={record.get('type')} />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow
            label={attrName('terminal_id')}
            value={record.get('terminal_id')}
          />
        </GridItem>

        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow
            label={attrName('username')}
            value={record.get('username')}
          />
        </GridItem>

        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow label={attrName('mode')} value={record.get('mode')} />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow label={attrName('ean')} value={record.get('ean')} />
        </GridItem>

        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow label={attrName('amount')} value={record.get('amount')} />
        </GridItem>

        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow
            label={attrName('currency')}
            value={record.get('currency')}
          />
        </GridItem>

        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow
            label={attrName('language')}
            value={record.get('language')}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow
            label={attrName('max_timeout')}
            value={record.get('max_timeout')}
          />
        </GridItem>

        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow
            label={attrName('local_datetime')}
            value={record.get('local_datetime')}
          />
        </GridItem>

        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow
            label={attrName('server_datetime')}
            value={
              record.get('server_datetime')
                ? moment(record.get('server_datetime')).format(
                    'DD/MM/YYYY HH:mm:ss'
                  )
                : ''
            }
          />
        </GridItem>

        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow
            label={attrName('valid_to')}
            value={
              record.get('valid_to')
                ? moment(record.get('valid_to')).format('DD/MM/YYYY HH:mm:ss')
                : ''
            }
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow label={attrName('serial')} value={record.get('serial')} />
        </GridItem>

        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow label={attrName('limit')} value={record.get('limit')} />
        </GridItem>

        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow
            label={attrName('created_at')}
            value={
              record.get('created_at')
                ? moment(record.get('created_at')).format('DD/MM/YYYY HH:mm:ss')
                : ''
            }
          />
        </GridItem>

        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow
            label={attrName('updated_at')}
            value={
              record.get('updated_at')
                ? moment(record.get('updated_at')).format('DD/MM/YYYY HH:mm:ss')
                : ''
            }
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow
            label={attrName('chars_per_line')}
            value={record.get('chars_per_line')}
          />
        </GridItem>

        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow
            label={attrName('receipt_quantity_lines')}
            value={record.get('receipt_quantity_lines')}
          />
        </GridItem>

        <GridItem xs={12} sm={6} md={6} lg={6} xl={6}>
          <InputShow
            label={attrName('receipt_body_lines')}
            value={record.get('receipt_body_lines')}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
          <InputShow label={attrName('result')} value={record.get('result')} />
        </GridItem>

        <GridItem xs={12} sm={10} md={10} lg={10} xl={10}>
          <InputShow
            label={attrName('result_text')}
            value={record.get('result_text')}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            label={attrName('status')}
            value={epayTransactionStatusOptions[record.get('status')]}
          />
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            type="object"
            digObject={['code']}
            label={attrName('pin')}
            value={record.get('pin')}
          />
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            type="object"
            digObject={['description']}
            label={attrName('product')}
            value={record.get('product')}
          />
        </GridItem>
      </GridContainer>
    </Paper>
  );
}

ShowEpayTransaction.propTypes = {
  history: historyPropType,
};

export default ShowEpayTransaction;
